/** mutations.js
 * vuex におけるmutationsの実装をする
 */
import {
  PREVIEWBOX_TIME_UPDATE,
  PREVIEWBOX_CLASSROOM_UPDATE,
  PREVIEWBOX_STYLE_UPDATE,
  PREVIEWBOX_SHOW_POPUP,
  PREVIEWBOX_HIDE_POPUP,
  RESERVATION_SHOW_POPUP,
  RESERVATION_HIDE_POPUP,
  RESERVATIONBOX_ENTER_EDIT,
  RESERVATIONBOX_ENTER_RESCHEDULING,
  RESCHEDULING_POPUP_HIDE,
  EDITINGBOX_TIME_UPDATE,
  EDITINGBOX_CLASSROOM_UPDATE,
  EDITINGBOX_STYLE_UPDATE,
  EDITING_POPUP_SHOW,
  EDITING_POPUP_HIDE,
  EDITINGBOX_DRAG_START,
  EDITINGBOX_DRAG_END,
  EDITINGSTATE_SET_STUDENT,
  EDITINGSTATE_SET_TEACHER,
  EDITINGSTATE_SET_MESSAGE,
  EDITINGSTATE_SET_HAS_TEST,
  EDITINGSTATE_SET_TYPE,
  EDITINGSTATE_SET_RECURRENCE,
  EDITINGSTATE_SET_IS_ONLINE,
  RESERVATIONBOX_FINISH_EDIT,
  RRULE_UPDATE,
  RESERVATIONS_UPDATE,
  USERINFO_UPDATE,
  LECTURE_UPDATE,
  USER_LECTURES_FETCH,
  USER_LIST_UPDATE,
  CLASSROOMS_FETCH,
  TIMETABLE_CHANGE_DATE,
  LOGIN,
  LOGIN_SUCCESS,
  LOGOUT,
  SPINNER_SHOW,
  SPINNER_HIDE,
  UPDATE_HEADER_HEIGHT,
  SHOW_INFORMATION_POPUP,
  HIDE_INFORMATION_POPUP,
  ATTENDANCE_UPDATE,
  SET_RESCHEDULING_INFO,
  CHANGE_SCHOOL,
  SHOW_ONLINE,
  MODAL
} from './mutation_types'

export default {
  [PREVIEWBOX_TIME_UPDATE] (state, times) {
    if (times.start !== undefined) {
      state.previewBox.start = times.start
    }
    if (times.end !== undefined) {
      state.previewBox.end = times.end
    }
  },
  [PREVIEWBOX_STYLE_UPDATE] (state, style) {
    state.previewBox.style['top'] = style['top']
    state.previewBox.style['left'] = style['left']
    state.previewBox.style['bottom'] = style['bottom']
    state.previewBox.style['height'] = style['height']
  },
  [PREVIEWBOX_CLASSROOM_UPDATE] (state, classroom) {
    state.previewBox.classroom = classroom
  },
  [PREVIEWBOX_SHOW_POPUP] (state) {
    state.previewBox.isPopupShown = true
  },
  [PREVIEWBOX_HIDE_POPUP] (state) {
    state.previewBox.isPopupShown = false
  },
  [RESERVATION_SHOW_POPUP] (state) {
    state.reservationbox.isPopupShown = true
  },
  [RESERVATION_HIDE_POPUP] (state) {
    state.reservationbox.isPopupShown = false
  },
  [RESERVATIONBOX_ENTER_EDIT] (state, reservation) {
    state.editingState.id = reservation.id
    state.editingState.classroom = reservation.classroom
    state.editingState.start = reservation.start_time.slice(0, 5)
    state.editingState.end = reservation.end_time.slice(0, 5)
    state.editingState.recurrence_id = reservation['recurrence_id']
    state.editingState.teacher = reservation.teacher.id
    state.editingState.student = reservation.student.id
    state.editingState.message = reservation.message
    state.editingState.hasTest = reservation.has_test
    state.editingState.online = reservation.online === '1'
    state.editingState.reservationType = reservation.reservation_type
    state.editingState.isRecurrent = reservation.recurrence_id !== null && reservation.recurrence_id !== 0
    state.editingState.isPopupShown = true
  },
  [EDITINGBOX_TIME_UPDATE] (state, times) {
    if (times.start !== undefined) {
      state.editingState.start = times.start
    }
    if (times.end !== undefined) {
      state.editingState.end = times.end
    }
  },
  [EDITINGBOX_CLASSROOM_UPDATE] (state, classroom) {
    state.editingState.classroom = classroom
  },
  [EDITINGBOX_STYLE_UPDATE] (state, style) {
    state.editingState.style['top'] = style['top']
    state.editingState.style['left'] = style['left']
    state.editingState.style['height'] = style['height']
  },
  [EDITING_POPUP_SHOW] (state) {
    state.editingState.isPopupShown = true
  },
  [EDITING_POPUP_HIDE] (state) {
    state.editingState.isPopupShown = false
  },
  [EDITINGBOX_DRAG_START] (state) {
    state.editingState.isDragging = true
  },
  [EDITINGBOX_DRAG_END] (state) {
    state.editingState.isDragging = false
  },
  [RESERVATIONBOX_ENTER_RESCHEDULING] (state, reservation) {
    state.rescherdulingState.id = reservation.id
    state.rescherdulingState.classroom = reservation.classroom
    state.rescherdulingState.start = reservation.start_time.slice(0, 5)
    state.rescherdulingState.date = reservation.date
    state.rescherdulingState.end = reservation.end_time.slice(0, 5)
    state.rescherdulingState.recurrence_id = reservation['recurrence_id']
    state.rescherdulingState.teacher = reservation.teacher.id
    state.rescherdulingState.student = reservation.student.id
    state.rescherdulingState.message = reservation.message
    state.rescherdulingState.hasTest = reservation.has_test
    state.rescherdulingState.online = reservation.online === '1'
    state.rescherdulingState.reservationType = reservation.reservation_type
    state.rescherdulingState.isRecurrent = reservation.recurrence_id !== null && reservation.recurrence_id !== 0
    state.rescherdulingState.isPopupShown = true
  },
  [RESCHEDULING_POPUP_HIDE] (state) {
    state.rescherdulingState.isPopupShown = false
  },
  [RESERVATIONBOX_FINISH_EDIT] (state) {
    state.editingState.id = 0
    state.editingState.recurrence_id = 0
    state.editingState.teacher = 0
    state.editingState.student = 0
    state.editingState.message = ''
    state.editingState.hasTest = false
    state.editingState.reservationType = '通常'
    state.editingState.isRecurrent = false
    state.editingState.isPopupShown = false
    state.editingState.online = false
  },
  [RRULE_UPDATE] (state, rrule) {
    state.recurrentRule = rrule
  },
  [RESERVATIONS_UPDATE] (state, reservations) {
    state.reservations = reservations
  },
  [USERINFO_UPDATE] (state, userinfo) {
    state.userInfo = userinfo
  },
  [LECTURE_UPDATE] (state, lectures) {
    state.lectureInfo = lectures
  },
  [USER_LECTURES_FETCH] (state, lectures) {
    state.userLectures = lectures
  },
  [USER_LIST_UPDATE] (state, userlist) {
    state.userlist = userlist
  },
  [CLASSROOMS_FETCH] (state, classrooms) {
    state.classrooms = classrooms
  },
  [TIMETABLE_CHANGE_DATE] (state, payload) {
    state.curDate = payload.date
  },
  [LOGIN] (state) {
    state.pending = true
  },
  [LOGIN_SUCCESS] (state) {
    state.isLoggedIn = true
    state.pending = false
  },
  [LOGOUT] (state) {
    state.isLoggedIn = false
  },
  [SPINNER_SHOW] (state) {
    state.spinning = true
  },
  [SPINNER_HIDE] (state) {
    state.spinning = false
  },
  [UPDATE_HEADER_HEIGHT] (state, height) {
    state.tbHeaderHeight = height
  },
  [HIDE_INFORMATION_POPUP] (state) {
    state.isInfoPopupShown = false
  },
  [SHOW_INFORMATION_POPUP] (state, reservation) {
    state.informationPopup.reservation = reservation
    state.isInfoPopupShown = true
  },
  [EDITINGSTATE_SET_TEACHER] (state, teacher) {
    state.editingState.teacher = teacher
  },
  [EDITINGSTATE_SET_STUDENT] (state, student) {
    state.editingState.student = student
  },
  [EDITINGSTATE_SET_MESSAGE] (state, val) {
    state.editingState.message = val
  },
  [EDITINGSTATE_SET_HAS_TEST] (state, val) {
    state.editingState.hasTest = val
  },
  [EDITINGSTATE_SET_TYPE] (state, val) {
    state.editingState.reservationType = val
  },
  [EDITINGSTATE_SET_RECURRENCE] (state, val) {
    state.editingState.isRecurrent = val
  },
  [EDITINGSTATE_SET_IS_ONLINE] (state, val) {
    state.editingState.online = val
  },
  [ATTENDANCE_UPDATE] (state, attendanceList) {
    let list = []
    for (let atd of attendanceList) {
      list.push(atd.user_id)
    }
    state.attendance = list
  },
  [SET_RESCHEDULING_INFO] (state, reschedulingInfo) {
    state.reschedulingInfo = reschedulingInfo
  },
  [CHANGE_SCHOOL] (state, schoolid) {
    state.userInfo.school_id = schoolid
  },
  [SHOW_ONLINE] (state, showOnline) {
    state.showOnline = showOnline
  },
  [MODAL] (state, modal) {
    state.modal.trigger = true
    state.modal.text = modal
  }
  // },
  // [TOGGLE_USER_ATTENDANCE] (state, userId) {
  //   if (userId in state.attendance) {
  //     state.attendance.some((v, i) => {
  //       if (v === userId) {
  //         state.attendance.splice(i, 1)
  //       }
  //     })
  //   } else {
  //     state.attendance.push(userId)
  //   }
  // }
}



// WEBPACK FOOTER //
// ./src/vuex/mutations.js